import React from "react";
import { privacy } from "./PrivacyPolicy";

const Privacy = () => {
    return <div className="privacy-policy-content" style={{margin: "10%"}} dangerouslySetInnerHTML={{ __html: privacy }} />;
};

export default Privacy;
